<template>
    <div class="modal-card view-contact-modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                Change Orders <strong>({{ total }})</strong>
            </p>
            <a href="#" class="gear" @click.prevent="isTableSettingsModalActive = true">
                <o-icon pack="fa" icon="gear" size="is-small" />
            </a>
        </header>
        <section class="modal-card-body">
            <div v-if="totalApproved" class="card">
                <div class="columns column is-12 toolbar-box">
                    <div class="column is-4">
                        <p class="has-text-centered">
                            <strong>Approved:</strong><br>
                            <span>{{ totalApproved }}</span>
                        </p>
                    </div>
                    <div class="column is-4">
                        <p class="has-text-centered">
                            <strong>Total Approved:</strong><br>
                            <span>{{ totalApprovedUSD | currency }}</span>
                        </p>
                    </div>
                    <div class="column is-4">
                        <p class="has-text-centered">
                            <strong>Approval Rate:</strong><br>
                            <span>{{ approvalRate }}%</span>
                        </p>
                    </div>
                </div>
                <div class="columns column is-12 toolbar-box">
                    <div class="column is-4">
                        <p class="has-text-centered">
                            <strong>Draft:</strong><br>
                            <span>{{ totalDraft }}</span>
                        </p>
                    </div>
                    <div class="column is-4">
                        <p class="has-text-centered">
                            <strong>Total Draft:</strong><br>
                            <span>{{ totalDraftUSD | currency }}</span>
                        </p>
                    </div>
                    <div class="column is-4">
                        <p class="has-text-centered">
                            <strong>Total Dropped:</strong><br>
                            <span>{{ totalDroppedAmount | currency }}</span>
                        </p>
                    </div>
                </div>
            </div><br>
            <o-table v-if="isTableVisible" class="project-width-table is-responsive is-responsive-xs-desktop"
                :data="paginatedData" :bordered="table.bordered" :striped="table.striped" :narrowed="table.narrowed"
                :checkable="table.checkable" :mobile-cards="table.mobileCards" :paginated="table.paginated"
                :pagination-simple="table.paginationSimple" :per-page="table.perPage"
                :default-sort="['created_at', 'desc']" :selected.sync="selected" :checked-rows="checkedRows"
                :loading="loading" :total="total" backend-sorting backend-pagination
                @update:checkedRows="$event => checkedRows = $event" @page-change="onPageChange" @sort="onSort">
                <template>
                    <template>
                        <div v-for="col in tableColumns">
                            <o-table-column :key="col.field" v-slot="{ row }" :field="col.field"
                                :label="col.field === 'actions' ? '' : col.label" :sortable="col.sortable">
                                <router-link v-if="col.field === 'last_editor_id'"
                                    :to="{ name: 'users.show', params: { slug: row.last_editor_id } }">
                                    {{ userNameById(row.last_editor_id) }}
                                </router-link>

                                <router-link v-if="col.field === 'number'"
                                    :to="{ name: 'change-orders.edit', params: { slug: row.id, proposal: row } }">
                                    {{ row.number }}
                                </router-link>

                                <span v-if="col.field === 'status'">{{ getChangeOrderStatus(row) }}</span>
                                <span v-if="col.field === 'status_updated_at'">
                                    {{ $filters.valueOrDefault($filters.datetime(row.status_updated_at)) }}
                                </span>
                                <router-link v-if="col.field === 'created_by'"
                                    :to="{ name: 'users.show', params: { slug: row.created_by } }">
                                    {{ userNameById(row.created_by) }}
                                </router-link>
                                <span v-if="col.field === 'created_at'">{{ $filters.datetime(row.created_at) }}</span>
                                <span v-if="col.field === 'updated_at'">{{ $filters.datetime(row.updated_at) }}</span>

                                <span v-if="col.field === 'floor_number'">{{ $filters.valueOrDefault(row.floor_number)
                                    }}</span>
                                <span v-if="col.field === 'company'">{{ companyNameById(row.company_id) }}</span>
                                <span v-if="col.field === 'contact'">{{ contactNameById(row.contact_id) }}</span>
                                <span v-if="col.field === 'approval_deadline'">{{
                    $filters.valueOrDefault($filters.date(row.approval_deadline)) }}</span>
                                <span v-if="col.field === 'notes'">{{ row.notes }}</span>
                                <span v-if="col.field === 'total_price'">{{ $filters.currency(row.total_price) }}</span>
                                <span v-if="col.field === 'deposit_percent'">{{ row.deposit_percent }}</span>
                                <span v-if="col.field === 'pay_in_full'">{{ $filters.yesNo(row.pay_in_full) }}</span>
                                <span v-if="col.field === 'sent_at'">{{
                    $filters.valueOrDefault($filters.datetime(row.sent_at)) }}</span>

                                <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left"
                                    class="table-actions">
                                    <template #trigger>
                                        <button class="button">
                                            <o-icon pack="fa" icon="ellipsis-v" />
                                        </button>
                                    </template>
                                    <o-dropdown-item has-link>
                                        <router-link
                                            :to="{ name: 'change-orders.edit', params: { slug: row.id, proposal: row } }">
                                            Edit
                                        </router-link>
                                    </o-dropdown-item>
                                    <o-dropdown-item has-link>
                                        <a :href="`/proposals/${row.id}/pdf`"
                                            @click.prevent="openPdfPreviewModal(row)">Preview PDF</a>
                                    </o-dropdown-item>
                                    <o-dropdown-item has-link>
                                        <a :href="`/change-orders/${row.id}/pdf?dl=0'`" target="_blank">Download PDF</a>
                                    </o-dropdown-item>
                                    <o-dropdown-item has-link>
                                        <a
                                            @click="openMessageModal({ entity: row, entity_type: 'change-order', context: 'change-order-message' })">Send
                                            to
                                            Customer</a>
                                    </o-dropdown-item>
                                    <o-dropdown-item has-link>
                                        <a @click="openReminderModal(row.id)">Set Reminder</a>
                                    </o-dropdown-item>
                                    <o-dropdown-item v-if="row.status === 'draft'" has-link>
                                        <a @click.prevent="handleDecline(row)">Decline</a>
                                    </o-dropdown-item>
                                    <o-dropdown-item v-if="row.status === 'draft'" has-link>
                                        <a @click.prevent="handleApprove(row)">Approve</a>
                                    </o-dropdown-item>
                                </o-dropdown>
                            </o-table-column>
                        </div>
                    </template>
                </template>

                <div slot="empty" class="has-text-centered">
                    This table is empty!
                </div>
            </o-table>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">
                Close
            </button>
        </footer>

        <o-modal v-model:active="isReminderModalActive" :can-cancel="['escape', 'outside', 'button']" scroll="keep"
            has-modal-card>
            <reminder-modal :reference-id="changeOrderId" reference-type="change-order" />
        </o-modal>

        <o-modal v-model:active="isPdfPreviewActive" :can-cancel="['escape', 'outside', 'button']" scroll="keep"
            has-modal-card :width="960">
            <preview-modal :file="currentPreviewFile" />
        </o-modal>

        <o-modal v-model:active="isTableSettingsModalActive" :can-cancel="['escape', 'outside', 'button']" scroll="keep"
            has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName" />
        </o-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Table from './../../mixins/Table'
import PreviewModal from './Preview'
import { getChangeOrderStatus } from './../../store/modules/change-orders/utils'

export default {

    components: {
        PreviewModal
    },
    mixins: [Table],

    props: ['year', 'month'],

    data() {
        return {
            tableName: 'change-orders-stats',
            isTableSettingsModalActive: false,
            isReminderModalActive: false,
            isPdfPreviewActive: false,
            currentPreviewFile: null,
            totalApproved: null,
            totalDraft: null,
            totalDroppedAmount: null,
            totalApprovedUSD: null,
            totalDraftUSD: null,
            approvalRate: null,
            changeOrderId: null,
            requestParams: {
                year: this.year,
                month: this.month,
                stats: true
            }
        }
    },

    computed: {
        ...mapGetters({
            itemsByIds: 'changeOrdersByIds'
        }),
        ...mapGetters([
            'projectById',
            'userNameById',
            'currentProjectId',
            'contactNameById',
            'companyNameById'
        ]),


    },

    mounted() {
        this.fetchPaginatedData(true, this.requestParams).then(result => {
            this.totalApproved = result.data.stats.totalApproved
            this.totalDraft = result.data.stats.totalDraft
            this.totalDroppedAmount = result.data.stats.totalDroppedAmount
            this.totalApprovedUSD = result.data.stats.totalApprovedUSD
            this.totalDraftUSD = result.data.stats.totalDraftUSD
            this.approvalRate = (this.totalApproved / this.total * 100).toFixed(2)
        })
    },

    methods: {
        ...mapActions({
            removeItem: 'removeChangeOrder',
            fetchData: 'fetchChangeOrders'
        }),

        ...mapActions([
            'approveChangeOrder',
            'declineChangeOrder',
            'openMessageModal',
        ]),

        getChangeOrderStatus,

        handleApprove(co) {
            this.confirmMessage(
                'Are you sure?',
                'This action cannot be undone.',
                'Yes'
            ).then(() => {
                this.approveChangeOrder(co)
                    .then(res => {
                        this.successMessage('Change Order approved')
                        return res
                    })
            })
        },

        handleDecline(co) {
            this.confirmMessage(
                'Are you sure?',
                'This action cannot be undone.',
                'Yes'
            ).then(() => {
                this.declineChangeOrder(co)
                    .then(res => {
                        this.successMessage('Change Order declined')
                        return res
                    })
            })
        },

        openPdfPreviewModal(changeOrder) {
            const port = window.location.port ? `:${window.location.port}` : '';
            this.currentPreviewFile = {
                name: `Change Order #${changeOrder.number}`,
                mime: 'application/pdf',
                path: `${window.location.protocol}//${window.location.hostname}${port}/change-orders/${changeOrder.id}/pdf`,
                generatedOnTheFly: true
            }
            this.isPdfPreviewActive = true
        },
        openReminderModal(changeOrderId) {
            this.isReminderModalActive = true
            this.changeOrderId = changeOrderId
        }
    }
}
</script>

<style scoped>
.modal-card {
    width: 100%;
}
</style>
